import { createSlice } from "@reduxjs/toolkit";
import {
  showAnnouncementUser,
  createAnnouncementUser,
  showAnnouncementByUser,
} from "../actions";

const initialState = {
  announcementUser: [],
};

const announcementUserSlice = createSlice({
  name: "announcementUser",
  initialState,
  reducers: {},
  extraReducers: {
    [showAnnouncementUser.fulfilled]: (state, action) => {
      state.announcementUser = action.payload || [];
    },
    [createAnnouncementUser.fulfilled]: (state, action) => {
      state.announcementUser = action.payload || [];
    },
    [showAnnouncementByUser.fulfilled]: (state, action) => {
      state.announcementUser = action.payload || [];
    },
  },
});

export const responseAnnouncementUser = (state) => state.announcementUser;

export default announcementUserSlice.reducer;
